window.YearSelector = function (el) {
	this.$el = el;
	this.$mask = $('.years-mask');
	this.$years = $('.years');
	this.init();
}

YearSelector.prototype = {

	init: function () {
		var _this = this;

		// bind year buttons
		this.$el.find('.years a').on('click', function () {
			_this.clickYearButton($(this));
			return false;
		});

		// resize event
		$window.on('resize', this.alignYear.bind(this));
		setTimeout(this.alignYear.bind(this), 100);
	},

	setYear: function (year) {
		// find year
		$('.years a[data-year="' + year + '"]').addClass('on').siblings().removeClass('on');
		this.alignYear();
	},

	clickYearButton: function ($btn) {
		var year = $btn.text();
		var index = $('.slide[data-year="' + year + '"]').data('index');
		$('.slides').slick('slickGoTo', index);
		this.setYear(year);

		_gte('history', {
			'event_category': document.title,
			'event_label': 'year - ' + year,
		});
	},

	setYearBySlideIndex: function (index) {
		// find year
		var year = $('.years a[data-index="' + index + '"]').text();
		this.setYear(year);
	},

	goNextYear: function () {
		$next = $('.years a.on').next();
		if (!$next.length) $next = $('.years a').first();
		$next.click();
		return false;
	},

	goPrevYear: function () {
		$prev = $('.years a.on').prev();
		if (!$prev.length) $prev = $('.years a').last();
		$prev.click();
		return false;
	},

	alignYear: function () {
		$yearBtn = $('.years a.on');
		var btnX = $yearBtn.index() * 60;
		var maskX = this.$mask[0].getBoundingClientRect().x;
		var half = window.innerWidth / 2;

		var offsetX = half - btnX - maskX - 35;

		this.$years.css('transform', 'translateX(' + offsetX + 'px)');
	}
}
